import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { CalendarCheckbox, ColoredCircle } from './ScheduleTypeCellParamTemplateDetailsStyles';
import { get, set } from '@totalsoft/change-tracking-react';
import { onCheckBoxChange } from 'utils/propertyChangeAdapters';

function ScheduleTableCell({ cellDataLens, dataColumns }) {
  const cellData = cellDataLens |> get;

  return (
    <Grid container flexDirection={'column'}>
      <Grid item xs={12}>
        <CalendarCheckbox checked={Boolean(cellData.selected)} onChange={cellDataLens.selected |> set |> onCheckBoxChange} />
      </Grid>
      <Grid item container justifyContent='center' xs={12} sx={{ minHeight: 16 }}>
        {dataColumns?.map((column, index) =>
          cellData[column.cellParamName] ? (
            <ColoredCircle key={index} colorIndex={index} sx={theme => ({ fontSize: theme.spacing(1.5) })} />
          ) : null
        )}
      </Grid>
    </Grid>
  );
}

ScheduleTableCell.propTypes = {
  cellDataLens: PropTypes.object.isRequired,
  dataColumns: PropTypes.array.isRequired
};

export default ScheduleTableCell;
